import styled from 'styled-components';
import {
    min_xs,
    min_sm,
    min_md,
    min_lg,
    min_lm,
    min_xl,
    min_fhd,
    max_xs,
    max_sm,
    max_md,
    max_lg,
    max_lm,
    max_xl,
    max_fhd,
} from "../variables";
import { BotonOD } from '../oferta-digital/common';

const loaderCSs = `

.panel {
    text-align:center;
  
    .spin {
      width: 50px;
      height: 50px;
      position: relative;
      border: 10px solid #f3f3f3;
      border-top: 10px solid #fcbf6c;
      border-radius: 50%;
      animation: spin 2s linear infinite;
      display:inline-block;
      vertical-align:middle;
      margin-right : 20px;
    }
  
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  
    & > .text {
      font-size: 15px;
      line-height: 20px;
      display:inline-block;
      vertical-align: middle;
    }
  
  }
  

`

export const ModalContainer = styled.div`

    width : 100%;
    position:fixed;
    top:0;
    left:0;
    z-index : 100;
    height : 100vh;

    background: rgba(0,0,0,0.8);
    .container{
        position:absolute;
        opacity:1;
        max-height : calc(100vh - 50px);
        width : 100%;
        top:50%;
        transform : translateY(-50%);
        overflow-y : auto;
    }

    .container ::-webkit-scrollbar {
        width: 0px;
    }

    *{
        box-sizing:border-box;
    }
    .modal{
        @media(${min_md}){
            padding:37px 59px;
        }
        @media(${max_md}){
            padding:30px 10px;
             margin-bottom:60px;
        }
        margin : auto;
        background: #FFFFFF;
        border-radius: 20px;
        width : 831px;
        max-width : 95%;
  
        &__content{
            max-height : calc(100vh - 200px);
            overflow-y: scroll;

            padding-bottom: 25px;

            -ms-overflow-style: none; 
            scrollbar-width: none;  
            ::-webkit-scrollbar {
                display: none;
            }
        }
        
        &__header{
            @media(${max_md}){
                text-align:center;
            }
            &__img{
                display:inline-block;
                width : 241px;
                @media(${max_md}){
                    width : 137px;
                }
                text-align:right;
                vertical-align : top;
                img{
                    width : 147px;
                }
                @media(${max_md}){
                    width : 137px;
                }
            }
            &__text{
                display:inline-block;
                text-align:left;
                width : 364px;
                vertical-align : top;
                padding-left : 15px;
                @media(${max_md}){
                    max-width : calc(100% - 137px);
                }
                h1{
                    font-size: 30px;
                    line-height: 25px;
                    color: #F59100;
                    margin:0;
                    margin-bottom:25px;
                    @media(${max_md}){
                        font-size: 20px;
                        line-height: 23px;
                        letter-spacing: 1.6875px;
                        margin-bottom:5px;
                    }

                }
                p{
                    margin-bottom:9px;
                    margin-top:0;
                    @media(${max_md}){
                        margin-bottom:5px;
                    }
                }
                span{
                    font-size: 18px;
                    line-height: 25px;
                    color: #979797;
                    @media(${max_md}){
                        font-size: inherit;
                        line-height: inherit;
                    }
                }
            }
        }

        &__body{
            margin-top : 30px;
            @media(${max_md}){
                font-size : 18px;
            }
        }
        .md-middle{
            @media(${max_md}){
                text-align:center;
            }
        }

        &__footer{
            
            border-top: 1px solid gray;
            padding-top: 25px;
            position:relative;

            @media(${min_md}){
                width: calc(100% + 118px);
                left: -59px;
            }
            @media(${max_md}){
                width: calc(100% + 20px);
                left: -10px;
            }

            ${BotonOD}{
                margin:auto;
            }
        }
    }
    .input-modal{
        min-height : 221px;
        width : 560px;
        @media(${max_md}){
            width : 320px;
            padding : 30px 50px 30px 30px;
        }
    }
    .input-title{
        font-weight: 600;
        @media(${min_md}){
            font-size: 20px;
            line-height: 25px;
        }
        @media(${max_md}){
            font-size: 20px;
            line-height: 25px;
            text-align:left;
        }
        color: #000000;
    }

    .modal-center{
        text-align:center;
    }
    .margin-top{
        @media(${min_md}){
            margin-top:50px;
        }
    }
    .progressbar{
        display:block;
        margin:52px auto 44px auto;
        max-width : 100%;
        width : 635px;
    }
    .right-align{
        text-align:right;
    }
    .cancel_close_tag{
        color : #4F5D5B;
        margin-right : 76px;
        :hover{
            cursor:pointer;
        }
    }
    .close_tag{
        color: #F7924E;
        :hover{
            cursor:pointer;
        }
    }
    .small-modal{
        width: 280px;
        padding: 30px 10px;
    }
    .medium-modal{
        width : 472px;
        padding : 35px;
    }
    ${loaderCSs}
    .title{
        font-size: 24px;
        line-height: 30px;
        font-weight: bold;
        color: #F59100;
        margin-bottom:30px;
    }
    .black{
        color : black;
    }
    .medium_content{
        margin:auto;
        max-width : 296px;
    }
    ${props => !props.display ? 'display:none;' : ''}

`

export const DocumentGridStyle = styled.div`

    .document__col{

        display:inline-block;
        vertical-align:top;
        @media(${min_md}){
            width : calc(100% * (1/3));
            border-right : 1px solid #EDEDED;
            :last-child{
                border-right : none;
            }
        }
        @media(${max_md}){
            width : 100%;
            border-bottom:1px solid #EDEDED;
            :last-child{
                border-bottom : none;
            }
        }
        
    }
    .document{
    
        @media(${min_md}){
            border-bottom:1px solid #EDEDED;
            padding-left : 27px;
            padding-top:17px;
            min-height : 120px;
            :last-child{
                border-bottom : none;
            }
        }
        @media(${max_md}){
            width : 50%;
            padding-left : 26px;
            padding-top:20px;
            padding-bottom:20px;
            padding-right : 20px;
            display:inline-block;
            vertical-align:top;
            border-right : 1px solid #EDEDED;
            :last-child{
                border-right : none;
            }
        }

        &__img{
            img{
                height : 25px;
            }
            margin-bottom : 10px;
        }
        &__title{
            font-weight: 600;
            font-size: 18px;
            line-height: 23px;
            color: #4F5D5B;

            @media(${max_md}){
                font-size: 16px;
                line-height: 20px;
            }
        }
        &__explanation{
            margin-top:5px;
            font-size: 14px;
            line-height: 18px;
            color: #979797;
        }
    }
    .desktop{
        @media(${max_md}){
            display:none;
        }
    }
    .mobile{
        @media(${min_md}){
            display:none;
        }
    }
    
`